import type { Common } from "@beautypie/segment";

import { isBrowser } from "@shared/utils.environment";

import type { DeepRequired } from "tracking";

import { emptyObjectReturn } from "./utils";

type Campaign = DeepRequired<
  Common,
  ["context", "campaign"]
>["context"]["campaign"];

export const parseCampaign = (): Campaign | undefined => {
  if (isBrowser()) {
    const url = new URL(window === undefined ? "" : window.location.href);
    const awc = sessionStorage.getItem("awc") || undefined;

    const campaign: Campaign = {
      id: url.searchParams.get("utm_id") || undefined,
      name: url.searchParams.get("utm_campaign") || undefined,
      source: url.searchParams.get("utm_source") || undefined,
      medium: url.searchParams.get("utm_medium") || undefined,
      term: url.searchParams.get("utm_term") || undefined,
      content: url.searchParams.get("utm_content") || undefined,
      awc
    };

    return emptyObjectReturn<Campaign>(campaign);
  }

  return undefined;
};
